import { apiRequestFirst } from "./client";

const jsonPost = (body) => ({
  method: "POST",
  body,
});

export const authApi = {
  register(payload) {
    return apiRequestFirst(["/auth/register", "/register"], jsonPost(payload));
  },

  login(payload) {
    return apiRequestFirst(["/auth/login", "/login"], jsonPost(payload));
  },

  me() {
    return apiRequestFirst(["/auth/me", "/auth/verify", "/verify", "/me"]);
  },

  verify() {
    return apiRequestFirst(["/auth/verify", "/verify", "/auth/me", "/me"]);
  },

  confirmEmail(payload) {
    return apiRequestFirst(
      ["/auth/confirm-email", "/confirm-email"],
      jsonPost(payload),
    );
  },

  resendConfirmation(payload) {
    return apiRequestFirst(
      ["/auth/resend-confirmation", "/resend-confirmation"],
      jsonPost(payload),
    );
  },

  forgotPassword(payload) {
    return apiRequestFirst(
      ["/auth/forgot-password", "/forgot-password"],
      jsonPost(payload),
    );
  },

  resetPassword(payload) {
    return apiRequestFirst(
      ["/auth/reset-password", "/reset-password"],
      jsonPost(payload),
    );
  },

  changePassword(payload) {
    return apiRequestFirst(
      ["/auth/change-password", "/change-password"],
      jsonPost(payload),
    );
  },

  logout() {
    return apiRequestFirst(["/auth/logout", "/logout"], {
      method: "POST",
    });
  },
};
